<template>
  <div>
    <test-plan-data-list category="story" :loading="loading" :table-data="tableData" :pagination="false" @reload="getPlanList" />
  </div>
</template>

<script>
import { testPlanList } from '@/api/project/testPlan';
import TestPlanDataList from '@/pages/project/testplan/components/TestPlanDataList';

export default {
  name: 'StroyTestPlan',
  components: {
    TestPlanDataList
  },
  props: {
    requirementId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      projectId: parseInt(this.$route.params.project_id) || null,
      loading: false,
      tableData: [],
      filterForm: {}
    };
  },
  mounted() {
    this.getPlanList();
  },
  methods: {
    getPlanList() {
      this.loading = true;
      testPlanList({ ...this.filterForm, requirement_id: this.requirementId, project_id: this.projectId })
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
